import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

import headerGeneral from '@/components/headerGeneral'
import sideMenu from '@/components/sideMenu'
import helpers from '@/mixins/helpers'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { FontAwesomeLayers} from '@fortawesome/vue-fontawesome'
import { dom } from '@fortawesome/fontawesome-svg-core'
dom.watch()
library.add(fas, far, fab)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)

import TwoColumns from "@/ecobods/layouts/TwoColumns"
import Dashboard from "@/ecobods/layouts/Dashboard"
Vue.component('TwoColumns-layout', TwoColumns)
Vue.component('Dashboard-layout', Dashboard)

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'


const requireComponent = require.context(
  // The relative path of the components folder
  '@/ecobods/components',
  // Whether or not to look in subfolders
  true,
  // The regular expression used to match base component filenames
  /Eb[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)
  
  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
      .split('/')
      .pop()
      .replace(/\.\w+$/, '')
    )
  )
  
  
  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})



Vue.component('headerGeneral', headerGeneral)
Vue.component('sideMenu', sideMenu)
Vue.mixin(helpers)

axios.defaults.withCredentials = true
axios.defaults.baseURL = process.env.VUE_APP_API_URL

Vue.config.productionTip = false

Vue.prototype.$http = axios
axios.interceptors.response.use(undefined, function (error) {
  if (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry && router.currentRoute.name != 'login') {
      
      originalRequest._retry = true;
      store.dispatch('LogOut')
      return router.push({name: 'login'})
    }
    else {
      return Promise.reject(error);
    }
  }
})

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
